/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2018-12-04 10:43:42
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-09-26 13:33:30
 * @Company: Inspur
 * @Version: v0.0.1
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FarrisCommonModule } from '@farris/ui-common';
import { InputGroupModule } from '@farris/ui-input-group';
import { LayoutModule } from '@farris/ui-layout';
import { LocaleModule} from '@farris/ui-locale';
import { FarrisDialogModule } from '@farris/ui-dialog';
import { MessagerModule } from '@farris/ui-messager';
import { DataTableModule, DataTableComponent } from '@farris/ui-datatable';
import { TreeTableModule, TreeTableComponent } from '@farris/ui-treetable';
import { LoadingModule } from '@farris/ui-loading';
import { NotifyModule } from '@farris/ui-notify';
import { FarrisContextMenuModule } from '@farris/ui-context-menu';
import { FarrisFormsModule } from '@farris/ui-forms';

import { LookupGridComponent } from './lookup-grid.component';
import { LookupComponent } from './lookup.component';
import { LookupLeftComponent } from './lookup-left.component';
import { LookupTabsComponent } from './lookup-tabs.component';
import { LookupTipDirective } from './lookup-tip.directive';

import { LookupQuickSelectPanelComponent } from './quick-select/quick-select-panel.component';
import { LookupQuickSelectDirective } from './quick-select/lookup-quick-select.directive';
import { LookupAdvancedLayoutComponent } from './advanced-layout/lookup-advanced-layout.component';
import { SearchBoxModule } from '@farris/ui-search-box';
import { LookupFilterBarComponent } from './advanced-layout/lookup-filter-bar.component';
import { LookupSelectedDirective } from './selected-list/lookup-selected.directive';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FarrisCommonModule.forRoot(),
        FarrisDialogModule.forRoot(),
        MessagerModule.forRoot(),
        NotifyModule.forRoot(),
        LoadingModule.forRoot({delay: 1000}),
        InputGroupModule,
        LayoutModule,
        DataTableModule,
        TreeTableModule,
        FarrisContextMenuModule,
        LocaleModule.forRoot(),
        SearchBoxModule,
        FarrisFormsModule
    ],
    exports: [
        LookupGridComponent, 
        LookupComponent,
        LookupAdvancedLayoutComponent
    ],
    declarations: [
        LookupGridComponent,
        LookupComponent,
        LookupLeftComponent,
        LookupTabsComponent,
        LookupTipDirective,
        LookupQuickSelectPanelComponent,
        LookupQuickSelectDirective,
        LookupAdvancedLayoutComponent,
        LookupFilterBarComponent,
        LookupSelectedDirective
    ],
    providers: [],
    entryComponents: [
        DataTableComponent, 
        TreeTableComponent, 
        LookupLeftComponent,
        LookupTabsComponent,
        LookupQuickSelectPanelComponent,
        LookupAdvancedLayoutComponent,
        LookupFilterBarComponent
    ]
})
export class LookupModule {}
